import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/DNSDUMPSTER/DNSDUMPSTER_01.png";
import Img_Two from "./../../../../sources/imgs/DNSDUMPSTER/DNSDUMPSTER_02.png";
import Img_Three from "./../../../../sources/imgs/DNSDUMPSTER/DNSDUMPSTER_03.png";
import Img_Four from "./../../../../sources/imgs/DNSDUMPSTER/DNSDUMPSTER_04.png";
import Img_Five from "./../../../../sources/imgs/DNSDUMPSTER/DNSDUMPSTER_05.png";
import Img_Six from "./../../../../sources/imgs/DNSDUMPSTER/DNSDUMPSTER_06.png";

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function DNSDUMPSTER (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> DNSDUMPSTER.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Introducción a DNSDumpster.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">DNSDumpster</span> es una <span className="span-white">herramienta gratuita</span> de <span className="span-pink">reconocimiento de dominios</span> que permite <span className="span-blue">descubrir hosts</span> y <span className="span-blue">subdominios</span> asociados a un <span className="span-white">dominio objetivo</span>. Es ampliamente <span className="span-pink">utilizada</span> en <span className="span-blue">pruebas de penetración</span>, <span className="span-blue">investigaciones de OSINT</span> y <span className="span-blue">análisis de superficie de ataque</span>, ya que proporciona <span className="span-pink">información detallada</span> sobre la <span className="span-white">infraestructura DNS</span> de una <span className="span-pink">organización</span>.
            </p>

            <p>
                Esta herramienta de <span className="span-white">inteligencia de código abierto</span> <i className="span-white">(OSINT)</i> permite realizar un <span className="span-pink">reconocimiento pasivo de dominios</span>. Al ingresar un <span className="span-blue">dominio</span>, la herramienta recopila <span className="span-white">información pública</span> relacionada, como <span className="span-blue">subdominios</span>, <span className="span-blue">registros DNS</span>, <span className="span-blue">direcciones IP</span> y <span className="span-blue">relaciones entre servicios</span>. Esto ayuda a <span className="span-white">mapear</span> la <span className="span-pink">superficie de ataque</span> de una <span className="span-pink">organización</span> <span className="span-white">sin interactuar directamente</span> con sus sistemas.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Sitio oficial a DNSDumpster.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">DNSDumpster</span> puede ser <span className="span-blue">consultado</span> y <span className="span-blue">utilizado</span> desde su <span className="span-white">sitio web oficial</span>. 
            </p>

            <p>
                <span className="span-pink">Consultar</span> la sitio: <a className="span-white" href="https://dnsdumpster.com/" target="_blank" rel="noopener noreferrer">DNSDumpster</a>.
            </p>

            <p>
                Puedes <span className="span-pink">obtener</span> el <span className="span-white">enlace</span> al <span className="span-pink">sitio</span> de <span className="span-yellow">DNSDumpster</span> en <span className="span-white">portapapeles</span> tambien:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "https://dnsdumpster.com/"
            />

            <p>
                <span className="span-pink">Imagen</span> de <span className="span-white">sitio oficial</span>:
            </p>

            <Img
                img = {Img_One}
                alt = {"Imagen 1. DNSDUMPSTER."}
                title = {"Descripcción de imagen."}
                text = {"1. Pagina oficial de DNSDUMPSTER."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Funciones principales de DNSDumpster.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Algunas <span className="span-pink">funciones</span> utiles por lo que <span className="span-yellow">DNSDumpster</span> puede serte <span className="span-white">util</span> son:
            </p>

            <ol className="ol-code">
                <li>
                    <p>
                        <span className="span-pink">Enumeración de subdominios:</span> Puede <span className="span-white">identificar subdominios</span> asociados al <span className="span-pink">dominio objetivo</span> utilizando fuentes como <span className="span-blue">registros de transparencia de certificados</span>, <span className="span-blue">motores de búsqueda</span> y <span className="span-blue">repositorios web</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Recuperación de registros DNS:</span> <span className="span-white">Obtiene</span> <span className="span-blue">registros A (IPv4)</span>, <span className="span-blue">AAAA (IPv6)</span>, <span className="span-blue">MX (correo)</span>, <span className="span-blue">NS (servidores de nombres)</span>, <span className="span-blue">TXT (información adicional)</span> y <span className="span-blue">CNAME (nombres canónicos)</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Mapa visual de la red:</span> <span className="span-white">Genera</span> un <span className="span-pink">gráfico interactivo</span> que muestra la relación entre <span className="span-blue">subdominios</span>, <span className="span-blue">direcciones IP</span> y <span className="span-blue">servidores</span>, facilitando la <span className="span-white">comprensión de la infraestructura</span> del <span className="span-pink">dominio</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Exportación de resultados:</span> Permite <span className="span-white">descargar los datos</span> obtenidos en formatos como <span className="span-blue">CSV</span>, <span className="span-blue">XLSX</span> o <span className="span-blue">PNG</span> para su <span className="span-white">análisis posterior</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Búsqueda inversa de DNS:</span> Facilita la <span className="span-white">identificación de dominios</span> asociados a una <span className="span-pink">dirección IP</span> específica, útil para <span className="span-white">descubrir relaciones</span> entre <span className="span-white">diferentes dominios</span>.
                    </p>
                </li>
            </ol>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Utilización de DNSDumpster.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <b>
                <p className="span span-blue">1. Ingresar dominio de red a reconocer.</p>
            </b>

            <p>
                Utilizar <span className="span-yellow">DNSDumpster</span> es muy <span className="span-pink">sencillo</span>, basta con <span className="span-pink">colocar el dominio</span> que deseamos reconocer para que la herramienta nos despliegue la <span className="span-white">información encontrada</span>.
            </p>

            <p>
                Veamos un <span className="span-white">ejemplo</span> en la <span className="span-pink">imagen</span>:
            </p>

            <Img
                img = {Img_Two}
                alt = {"Imagen 2. DNSDUMPSTER."}
                title = {"Descripcción de imagen."}
                text = {"2. Ingreso de dominio en DNSDUMPSTER."}
            />

            <p>
                <span className="span-yellow">
                    Nota:
                </span> A <span className="span-pink">continuación</span>, la <span className="span-white">herramienta</span> nos devolverá diferente <span className="span-blue">información sobre el dominio</span>, separada entre <span className="span-white">diferentes apartados</span>, los cuales explicaremos posteriormente.
            </p>

            <b>
                <p className="span span-blue">2. Apartado de System Locations.</p>
            </b>
                
            <p>
                El <span className="span-pink">apartado</span> de <i className="span-blue">System Locations</i> muestra <span className="span-white">información sobre las diferentes ubicaciónes</span> encontradas en las cuales se encuentra la <span className="span-pink">red</span>, tales como <span className="span-blue">ubicación de Hostings</span>, <span className="span-blue">nombres de los servicios</span> de hosting utilizados, <span className="span-blue">numeros</span> y <span className="span-blue">paises</span> en donde se encuentran alojados.
            </p>

            <p>
                Ademas, las <span className="span-white">graficas</span> permiten <span className="span-pink">visualizar</span> de una manera más intuitiva la <span className="span-blue">información</span> y <span className="span-blue">numeros</span>, abarcando los <span className="span-pink">servicios detectados</span> desde los cuales se alojan. 
            </p>

            <p>
                Un <span className="span-white">ejemplo</span> a <span className="span-pink">visualizar</span>: 
            </p>

            <Img
                img = {Img_Three}
                alt = {"Imagen 3. DNSDUMPSTER."}
                title = {"Descripcción de imagen."}
                text = {"3. Apartado de System Locations en DNSDUMPSTER."}
            />

            <p>
                <span className="span-yellow">Nota:</span> Toda esta <span className="span-white">recopilación de información</span> suele ser sumamente <span className="span-pink">util para reconocer</span> los servicios con los cuales puede funcionar el <span className="span-pink">objetivo</span>, en busca de <span className="span-blue">posibles vulnerabilidades</span> o <span className="span-blue">puntos debiles</span> a <span className="span-white">explorar</span> y <span className="span-white">atacar</span> en busca de <span className="span-pink">explotarlos</span>.
            </p>

            <b>
                <p className="span span-blue">3. Información de A Records (subdomains from dataset).</p>
            </b>

            <p>
                El <span className="span-pink">apartado</span> de <i className="span-blue"> A Records (subdomains from dataset)</i> provee <span className="span-white">información sobre los diferentes subdominios publicos</span> encontrados, asi como <span className="span-pink">información</span> sobre ellos, algunos datos de <span className="span-white">información</span> son: 
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-pink">Host:</span> <span className="span-white">Nombre del subdominio</span> encontrado (por <span className="span-pink">ejemplo</span>, <i className="span-blue">mail.ejemplo.com</i>).
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">IP:</span> <span className="span-white">Dirección IP asociada al subdominio</span>, lo cual permite identificar en qué <span className="span-pink">servidor</span> está <span className="span-pink">alojado</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">ASN:</span> <span className="span-white">Número de Sistema Autónomo (Autonomous System Number)</span> que <span className="span-pink">identifica</span> al <span className="span-blue"> proveedor de red</span> o <span className="span-blue">ISP responsable de la IP</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">ASN Name:</span> <span className="span-white">Nombre de la organización</span> o <span className="span-white">compañía</span> a la que pertenece el <span className="span-pink">ASN</span> (por <span className="span-pink">ejemplo</span>, <i className="span-blue">Cloudflare</i>, <i className="span-blue">Google LLC</i>, etc.).
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Open Services (from DB):</span> <span className="span-white">Servicios detectados</span> que podrían estar <span className="span-pink">activos</span> en esa <span className="span-white">IP</span>, como <span className="span-pink">puertos abiertos</span> (<i className="span-blue">HTTP</i>, <i className="span-blue">HTTPS</i>, <i className="span-blue">FTP</i>, etc.).
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">RevIP:</span> Resultado de la <span className="span-white">resolución inversa de IP (Reverse DNS)</span>, que puede mostrar el <span className="span-pink">nombre de dominio</span> asociado a la <span className="span-white">IP</span>.
                    </p>
                </li>
            </ul>

            <p>
                Tal como se muestra en la <span className="span-white">imagen</span> de <span className="span-pink">ejemplo</span>:
            </p>

            <Img
                img = {Img_Four}
                alt = {"Imagen 4. DNSDUMPSTER."}
                title = {"Descripcción de imagen."}
                text = {"4. Apartado de  A Records (subdomains from dataset) en DNSDUMPSTER."}
            />

            <b>
                <p className="span span-blue">4. Descarga de reporte XLSX.</p>
            </b>

            <p>
                <span className="span-yellow">DNSDumpster</span> permite <span className="span-white">descargar</span> un <span className="span-pink">reporte</span> sobre la <span className="span-blue">información recopilada</span> desde un archivo <i className="span-white">.xlsx</i>.
            </p>

            <p>
                Para ello, debemos hacer <span className="span-white">click</span> sobre el botón <span className="span-pink">"Dowload xlsx"
                </span>, lo que nos abrirá desde otra <span className="span-white">pestaña</span> el <span className="span-pink">reporte</span>, el cual podremos <span className="span-pink">descargar</span>.
            </p>

            <p>
                Veamos:
            </p>

            <Img
                img = {Img_Five}
                alt = {"Imagen 5. DNSDUMPSTER."}
                title = {"Descripcción de imagen."}
                text = {"5. Descarga de reporte XLSX."}
            />

            <b>
                <p className="span span-blue">5. Apartado de Mapa Esquematico de Red.</p>
            </b>

            <p>
                El apartado de <span className="span-white">Mapa Esquematico de Red</span>, nos muestra un <span className="span-pink">diagrama estructurado de la gerarquia de la red</span>, desde el <span className="span-blue">nombre de dominio</span>, <span className="span-blue">clase de red</span>, los <span className="span-blue">subdominios</span> y <span className="span-blue">DNS</span>.
            </p>

            <p>
                Tal como se muestra en la <span className="span-white">imagen</span> siguiente de <span className="span-pink">ejemplo</span>:
            </p>

            <Img
                img = {Img_Six}
                alt = {"Imagen 6. DNSDUMPSTER."}
                title = {"Descripcción de imagen."}
                text = {"6. Apartado de Mapa Esquematico de Red."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Consideraciones éticas y legales de DNSDumpster.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-pink">Recuerda</span>, es <span className="span-white">fundamental</span> utilizar <span className="span-yellow">DNSDumpster</span> de manera <span className="span-blue">ética</span> y <span className="span-blue">legal</span>:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-pink">Permiso:</span> Solo <span className="span-pink">analiza dominios</span> que te pertenezcan o para los cuales tengas <span className="span-white">autorización explícita</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Uso responsable:</span> <span className="span-pink">Evita</span> <span className="span-white">utilizar la información</span> obtenida para <span className="span-blue">actividades maliciosas</span> o <span className="span-blue">no autorizadas</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Privacidad:</span> <span className="span-pink">Respeta</span> la <span className="span-white">privacidad</span> de las <span className="span-blue">organizaciones</span> y no divulgues <span className="span-white">información sensible</span> <span className="span-pink">sin consentimiento</span>.
                    </p>
                </li>
            </ul>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Recursos extra de DNSDumpster.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Si deseas <span className="span-pink">conocer</span> más sobre <span className="span-yellow">DNSDumpster</span>, puedes consutar <span className="span-white">otros recursos</span>:
            </p>

            <ol className="ol-code">
                <li>
                    <p>
                        <span className="span-pink">Tutorial de uso en video:</span> Puedes consultar el <span className="span-white">tutorial</span> de uso desde: <a className="span-white" href="https://www.youtube.com/watch?v=mCQxd2h37OY" target="_blank" rel="noopener noreferrer">https://www.youtube.com/watch?v=mCQxd2h37OY</a>
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Documentación técnica:</span> Si deseas una <span className="span-pink">comprensión más profunda</span> de las capacidades de <span className="span-yellow">DNSDumpster</span>, consulta la <span className="span-white">documentación</span> oficial: <a className="span-white" href="https://infosecwriteups.com/exploring-dnsdumpster-unveiling-the-secrets-of-domain-infrastructure-c716b5b8c4a5" target="_blank" rel="noopener noreferrer">InfoSex White-ups</a> y <a className="span-white" href="https://www.syberseeker.com/2024/10/domain-osint-and-attack-surface-mapping.html" target="_blank" rel="noopener noreferrer">syberseeker.com</a>.
                    </p>
                </li>
            </ol>
        </>
    );
}